import * as casl from '@casl/ability';
import { TeamUser } from '../interfaces/team';
import UserRoles from '../enums/userRoles';
import { Resource } from '../enums/common';
import { PersonalUser } from '../interfaces/account';
import { MongoAbility, RawRuleOf } from '@casl/ability';

export const ROLE_HIERARCHY = {
  [UserRoles.MEMBER]: 1,
  [UserRoles.ADMIN]: 2,
  [UserRoles.OWNER]: 3,
};

type CaslAbility = casl.MongoAbility<casl.AbilityTuple, casl.MongoQuery>;

type EnhancedCanFunction = (
  action: string,
  subjectType: Resource,
  subject: any, // eslint-disable-line @typescript-eslint/no-explicit-any
  ...args: any[] // eslint-disable-line @typescript-eslint/no-explicit-any
) => boolean;

export interface Ability {
  can: EnhancedCanFunction;
}

const _enhanceAbility = (
  ability: CaslAbility
): { can: EnhancedCanFunction } => {
  const can: EnhancedCanFunction = (action, subjectType, subject, ...args) => {
    // Client-side business rule: Cloned orgs (with source_id) cannot be deleted
    if (
      action === 'delete' &&
      subjectType === Resource.OAuthCredential &&
      !!subject?.source_id
    ) {
      return false;
    }

    let enhancedSubject;
    if (subjectType === Resource.OAuthCredential) {
      enhancedSubject = { source_id: null, ...subject };
    } else {
      enhancedSubject = { ...subject };
    }
    return ability.can(
      action,
      casl.subject(subjectType, enhancedSubject),
      ...args
    );
  };
  return { can };
};

export function defineAbilityFor(
  user: TeamUser | PersonalUser | null | undefined
) {
  const rules = (user?.ability || []) as unknown as RawRuleOf<MongoAbility>[];
  const ability = casl.createMongoAbility(rules);
  return _enhanceAbility(ability);
}
